import actions from './actions';
import { createReducer, getError } from '../../../../../helpers/reducer';
import { keyBy } from '../../../../../helpers/core';

const initState = {
  loading: false,
  updateLoading: false,
  editForm: null,
  formInfo: {
    units: [],
    filteredUnits: [],
  },
};

function validate(/* attr, value */) {
  return false;
}

function onEdit(state) {
  return {
    ...state,
    loading: true,
  };
}

function onEditSuccess(state, { payload }) {
  let { talent_conversion_rule } = payload;

  if (talent_conversion_rule.exempted_units && talent_conversion_rule.exempted_units.length > 0) {
    talent_conversion_rule = {
      ...talent_conversion_rule,
      unit_exemption: true,
    };
  }

  const propsArray = Object.keys(talent_conversion_rule);

  const convertPropValue = prop => {
    switch (prop) {
      case 'exempted_units':
        return talent_conversion_rule[prop].map(item => {
          return { value: item.id, label: item.name };
        });
      default:
        return talent_conversion_rule[prop];
    }
  };

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: convertPropValue(prop),
      error: validate(prop, talent_conversion_rule[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
    loading: false,
  };
}

function onUpdate(state) {
  return {
    ...state,
    updateLoading: true,
  };
}

function onLoadFormData(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { units } = payload;

  return {
    ...state,
    loading: false,
    formInfo: {
      units,
      filteredUnits: units,
    },
  };
}

function onUpdateSuccess(state) {
  return {
    ...state,
    updateLoading: false,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm,
    baseError: null,
  };
}

function onChangeFilteredUnits(state, { payload }) {
  const { formInfo } = state;
  const { filteredUnits } = payload;

  return {
    ...state,
    formInfo: {
      ...formInfo,
      filteredUnits,
    },
  };
}

function onChangeSelectedUnits(state, { payload }) {
  const { exempted_units } = payload;
  const editForm = { ...state.editForm };

  editForm.exempted_units = {
    value: exempted_units,
    error: '',
    name: 'exempted_units',
    touched: true,
  };

  return {
    ...state,
    editForm,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(entry[0], data),
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
    updateLoading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_FORM_DATA]: onLoadFormData,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.UPDATE]: onUpdate,
  [actions.UPDATE_SUCCESS]: onUpdateSuccess,
  [actions.EDIT]: onEdit,
  [actions.EDIT_SUCCESS]: onEditSuccess,
  [actions.TOUCH]: onTouch,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CHANGE_FILTERED_UNITS]: onChangeFilteredUnits,
  [actions.CHANGE_SELECTED_UNITS]: onChangeSelectedUnits,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.CLEAR_STORE]: onClearStore,
});
